// NDH Theme - Umbraco Project JavaScript
// Import base NDH theme functionality
// Base NDH theme functionality is loaded via the main js/app.js file

// Umbraco-specific JavaScript functionality
console.log('NDH Umbraco theme JavaScript loaded');

// Add any Umbraco-specific JavaScript here
// Example: Umbraco grid customizations, form enhancements, etc.

/*
* 13238 — sidebar-band full-bleed (KD/PD/MHL only, this file is per-theme, not shared)
*
* Same shape as 13208's own hero-bleed (themes/shared/js/components.js, updateHeroBleed): a
* coloured Single Column Layout band living inside `.read-more-layout`'s 9-col main cell isn't
* centred on the viewport the way a normal page's content column is (the sidebar's 3-col cell
* sits to its right), so the CSS breakout's fixed vw-centring math
* (_sidebarbands13238.scss) can't reach the true viewport edges by a formula alone. This measures
* each band's own live distance from the viewport's left edge and writes it to a CSS custom
* property; the CSS then subtracts it back out via margin-left, landing the breakout at the true
* viewport edge regardless of viewport width or how deep the band happens to be nested. A no-op
* on every page without a `.read-more-layout` band (the vast majority of pages).
*/
(function () {
    function updateSidebarBandBleed() {
        var bands = document.querySelectorAll(
            '.read-more-layout section.section-spacing[style*="background-color"]:not(.split):not(.split-flush)'
        );
        for (var i = 0; i < bands.length; i++) {
            // Reset first: the CSS shifts the band by this same value, so measuring the shifted
            // band would read ~0 on the next resize and undo the correction (PR 9073 review).
            // getBoundingClientRect forces a sync layout, so the reset applies to the measurement.
            bands[i].style.setProperty('--band-bleed-left', '0px');
            var left = bands[i].getBoundingClientRect().left;
            bands[i].style.setProperty('--band-bleed-left', left + 'px');
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateSidebarBandBleed);
    } else {
        updateSidebarBandBleed();
    }

    var sidebarBandResizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(sidebarBandResizeTimer);
        sidebarBandResizeTimer = setTimeout(updateSidebarBandBleed, 150);
    });
})();

/*
* 13324 — old PD blog "Load more" (KD/PD/MHL only, this file is per-theme, not shared)
*
* Old's category pages show a category's first 3 posts and a "Load more" pill that shows 3 more each
* time (old reloaded with ?page=2, ?page=3; a ?page=N link still opens with 3 x N shown). On a Grid
* Cards block with Component Style = Blog and more than 3 cards, the 4th card on is hidden and the
* pill is added under the cards; each press shows the next 3 and moves focus to the first of them.
* Without JS every card shows. A no-op on every page without such a block.
*/
(function () {
    var PER_PAGE = 3;

    function initBlogLoadMore() {
        var grids = document.querySelectorAll('.callout.blog > .grid-x');
        var page = parseInt(new URLSearchParams(window.location.search).get('page'), 10);
        if (!(page > 0)) { page = 1; }
        for (var g = 0; g < grids.length; g++) {
            setUp(grids[g]);
        }

        function setUp(grid) {
            var cells = [];
            for (var c = 0; c < grid.children.length; c++) {
                if (grid.children[c].classList.contains('cell')) { cells.push(grid.children[c]); }
            }
            if (cells.length <= PER_PAGE || grid.parentElement.querySelector(':scope > .blog-load-more')) { return; }
            var shown = Math.min(cells.length, page * PER_PAGE);
            var wrap = document.createElement('div');
            wrap.className = 'blog-load-more';
            var link = document.createElement('a');
            link.textContent = 'Load more';
            wrap.appendChild(link);
            grid.parentElement.insertBefore(wrap, grid.nextSibling);

            function render() {
                for (var i = 0; i < cells.length; i++) { cells[i].hidden = i >= shown; }
                var next = new URLSearchParams(window.location.search);
                next.set('page', String(Math.floor(shown / PER_PAGE) + 1));
                link.href = '?' + next.toString();
                wrap.hidden = shown >= cells.length;
            }
            link.addEventListener('click', function (e) {
                e.preventDefault();
                var first = shown;
                shown = Math.min(cells.length, shown + PER_PAGE);
                render();
                var target = cells[first] && cells[first].querySelector('a');
                if (target) { target.focus(); }
            });
            render();
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initBlogLoadMore);
    } else {
        initBlogLoadMore();
    }
})();

/*
* 13303 — the page's own sidebar boxes (old PD's right-hand pods) start level with the page title, as on
* old, where the pods sit at the top of the row that the H1 opens. The CSS puts them 120px down
* (_relatedsidebar13303.scss), which is the title line on a page that opens with the breadcrumb and the
* text; a page that opens with full-width coloured bands (they bleed out of the content column,
* _sidebarbands13238.scss) has its title further down, under the bands, and the boxes must start there
* rather than over the bands. So, two columns only: find the content column's first H1 that is not in a
* hero or on a coloured band, and set the boxes' top margin to its offset; with no such H1, 60px under the
* hero as old (the CSS offsets stay as the fallback before this runs). Re-measured on load (images and films change heights), on resize and when the column
* resizes. A no-op on every page without sidebar boxes.
*/
(function () {
    var wide = window.matchMedia ? window.matchMedia('(min-width: 64em)') : null;

    function onBand(el, stop) {
        for (var e = el; e && e !== stop; e = e.parentElement) {
            if (e.classList && e.classList.contains('banner--hero')) return true;
            var bg = window.getComputedStyle(e).backgroundColor;
            if (bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'rgb(255, 255, 255)') return true;
        }
        return false;
    }

    function updateSidebarBoxesTop() {
        var all = document.querySelectorAll('.read-more-layout > .grid-x > .cell > .sidebar-boxes');
        for (var i = 0; i < all.length; i++) {
            var boxes = all[i];
            var column = boxes.parentElement.parentElement.firstElementChild;
            boxes.style.removeProperty('margin-top');
            if (!wide || !wide.matches || !column || column === boxes.parentElement) continue;
            var cellTop = boxes.parentElement.getBoundingClientRect().top;
            var top = -1;
            var h1s = column.querySelectorAll('h1');
            for (var j = 0; j < h1s.length; j++) {
                if (onBand(h1s[j], column)) continue;
                top = h1s[j].getBoundingClientRect().top - cellTop;
                break;
            }
            // no title of its own under a hero: old starts the pods 60px under the hero
            if (top < 0) {
                var heroes = column.querySelectorAll('.banner--hero');
                for (var h = 0; h < heroes.length; h++) top = Math.max(top, heroes[h].getBoundingClientRect().bottom - cellTop + 60);
            }
            if (top >= 0) boxes.style.marginTop = Math.round(top) + 'px';
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateSidebarBoxesTop);
    } else {
        updateSidebarBoxesTop();
    }
    window.addEventListener('load', updateSidebarBoxesTop);

    var sidebarBoxesTimer;
    function later() {
        clearTimeout(sidebarBoxesTimer);
        sidebarBoxesTimer = setTimeout(updateSidebarBoxesTop, 150);
    }
    window.addEventListener('resize', later);
    if (window.ResizeObserver) {
        var columns = document.querySelectorAll('.read-more-layout > .grid-x > .cell:first-child');
        var ro = new ResizeObserver(later);
        for (var k = 0; k < columns.length; k++) {
            if (columns[k].parentElement.querySelector(':scope > .cell > .sidebar-boxes')) ro.observe(columns[k]);
        }
    }
})();

/*
* PD modules cards2 (01/10/2026) - Grid Cards "Gallery" lightbox (kd only; this file is per-theme).
*
* Old PD's gallery opened its pictures and its thumbnail videos in a Bootstrap lightbox (ekko-lightbox):
* the video autoplaying 16:9 up to 1140 wide on a black .85 backdrop, a close cross top right, and on a
* picture old's previous / next boxes through the same gallery. A no-op on every page without a
* .callout.gallery block (cBBGGridCards.cshtml renders it only for Component Style "Gallery"):
*  - a video card with its OWN picture (the play button holds a .progressive-image) opens in the
*    lightbox instead of playing in place: the capture-phase listener below stops the click before the
*    shared play-in-place handlers (components.js, cardCarousel.js) see it;
*  - a video card without one (a YouTube automatic thumbnail) is old's embedded player: it still plays
*    in place, and its player then joins the tab order and takes focus (gridCard.cshtml keeps the empty
*    iframe out of both; in a carousel cardCarousel.js lifts them, in a grid nothing did);
*  - a picture card with no link gets a button that opens the picture.
* The dialog is a native <dialog> (focus kept inside, Esc closes); closing it empties the player.
* Styles: _cards2pdmod.scss.
*/
(function () {
    var dialog = null;
    var dialogBody = null;
    var prevButton = null;
    var nextButton = null;
    var items = [];
    var current = -1;
    var opener = null;

    function directChild(parent, className) {
        for (var i = 0; parent && i < parent.children.length; i++) {
            if (parent.children[i].classList.contains(className)) {
                return parent.children[i];
            }
        }
        return null;
    }

    // The element that opens a card in the lightbox, or null when the card does not open in it.
    function openerOf(card) {
        var video = directChild(card, 'responsive-video--card');
        var overlay = directChild(video, 'video-thumbnail-overlay');
        if (overlay) {
            return directChild(overlay, 'progressive-image') ? overlay : null;
        }
        return video ? null : directChild(card, 'cards2-zoom');
    }

    function cardsOf(gallery) {
        var cards = gallery.querySelectorAll('.card');
        var list = [];
        for (var i = 0; i < cards.length; i++) {
            if (openerOf(cards[i])) {
                list.push(cards[i]);
            }
        }
        return list;
    }

    function pictureUrl(img) {
        var src = img.currentSrc || img.src || '';
        // The card asks for an 800px rendition; the lightbox shows up to 1140.
        return src.replace(/([?&]width=)\d+/, function (m, p) { return p + '1140'; });
    }

    function build() {
        dialog = document.createElement('dialog');
        dialog.className = 'cards2-lightbox';
        dialog.setAttribute('aria-label', 'Gallery');
        dialog.innerHTML =
            '<div class="cards2-lightbox__dialog">' +
                '<div class="cards2-lightbox__header">' +
                    '<button type="button" class="cards2-lightbox__close" aria-label="Close"></button>' +
                '</div>' +
                '<div class="cards2-lightbox__body"></div>' +
            '</div>';
        dialogBody = dialog.querySelector('.cards2-lightbox__body');
        prevButton = document.createElement('button');
        prevButton.type = 'button';
        prevButton.className = 'cards2-lightbox__prev';
        prevButton.setAttribute('aria-label', 'Previous');
        nextButton = document.createElement('button');
        nextButton.type = 'button';
        nextButton.className = 'cards2-lightbox__next';
        nextButton.setAttribute('aria-label', 'Next');
        document.body.appendChild(dialog);

        dialog.querySelector('.cards2-lightbox__close').addEventListener('click', function () { dialog.close(); });
        // A click on the backdrop (the dialog's own padding box) or beside the close cross closes, as old's modal did.
        dialog.addEventListener('click', function (e) {
            if (e.target === dialog || (e.target && e.target.classList.contains('cards2-lightbox__header'))) {
                dialog.close();
            }
        });
        dialog.addEventListener('close', function () {
            dialogBody.innerHTML = ''; // stops the video
            if (opener && document.body.contains(opener)) {
                opener.focus({ preventScroll: true });
            }
        });
        prevButton.addEventListener('click', function () { show(current - 1); });
        nextButton.addEventListener('click', function () { show(current + 1); });
    }

    function show(index) {
        var count = items.length;
        current = ((index % count) + count) % count;
        var card = items[current];
        var trigger = openerOf(card);
        // Clearing the body takes the arrows out of the DOM; remember which one had keyboard focus so it gets it back.
        var focusedArrow = document.activeElement === prevButton || document.activeElement === nextButton ? document.activeElement : null;
        dialogBody.innerHTML = '';
        if (trigger.classList.contains('video-thumbnail-overlay')) {
            var url = trigger.getAttribute('data-embed-url') || '';
            var frame = document.createElement('iframe');
            var title = card.querySelector('.card__title');
            frame.setAttribute('title', title ? title.textContent.trim() : 'Video');
            frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
            frame.setAttribute('allowfullscreen', '');
            frame.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
            var box = document.createElement('div');
            box.className = 'cards2-lightbox__video';
            box.appendChild(frame);
            dialogBody.appendChild(box);
        } else {
            var img = card.querySelector('img.card__image');
            var picture = document.createElement('img');
            picture.className = 'cards2-lightbox__image';
            picture.alt = img ? img.alt : '';
            picture.src = img ? pictureUrl(img) : '';
            dialogBody.appendChild(picture);
            // Old's gallery arrows show on pictures only, when there is somewhere to go.
            if (count > 1) {
                dialogBody.appendChild(prevButton);
                dialogBody.appendChild(nextButton);
            }
        }
        if (focusedArrow) {
            if (focusedArrow.isConnected) {
                focusedArrow.focus({ preventScroll: true });
            } else {
                // The next item is a video (no arrows): keep focus inside the dialog, on the close button.
                dialog.querySelector('.cards2-lightbox__close').focus({ preventScroll: true });
            }
        }
    }

    function open(trigger) {
        var card = trigger.closest('.card');
        var gallery = trigger.closest('.callout.gallery');
        if (!card || !gallery) {
            return;
        }
        if (!dialog) {
            build();
        }
        items = cardsOf(gallery);
        opener = trigger;
        show(items.indexOf(card));
        if (typeof dialog.showModal === 'function') {
            dialog.showModal();
        } else {
            dialog.setAttribute('open', '');
        }
        dialog.querySelector('.cards2-lightbox__close').focus({ preventScroll: true });
    }

    // Capture phase: runs before the play-in-place handlers bound on the button itself.
    document.addEventListener('click', function (e) {
        var trigger = e.target && e.target.closest ? e.target.closest('.callout.gallery .video-thumbnail-overlay, .callout.gallery .cards2-zoom') : null;
        if (!trigger || openerOf(trigger.closest('.card')) !== trigger) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        open(trigger);
    }, true);

    // Bubble phase, after the shared handler has started a play-in-place video in a grid: let its player in.
    document.addEventListener('click', function (e) {
        var overlay = e.target && e.target.closest ? e.target.closest('.callout.gallery > .grid-x .video-thumbnail-overlay') : null;
        var frame = overlay && overlay.parentNode ? overlay.parentNode.querySelector('iframe') : null;
        if (frame) {
            frame.removeAttribute('tabindex');
            frame.removeAttribute('aria-hidden');
            frame.focus({ preventScroll: true });
        }
    });

    function addZoomButtons() {
        var cards = document.querySelectorAll('.callout.gallery .card--type-1:not(.card--video)');
        for (var i = 0; i < cards.length; i++) {
            var card = cards[i];
            var picture = directChild(card, 'progressive-image') || directChild(card, 'card__image');
            if (!picture || card.querySelector('a.button') || directChild(card, 'cards2-zoom')) {
                continue;
            }
            var img = card.querySelector('img.card__image');
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'cards2-zoom';
            button.setAttribute('aria-label', 'Enlarge image' + (img && img.alt ? ': ' + img.alt : ''));
            card.appendChild(button);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', addZoomButtons);
    } else {
        addZoomButtons();
    }
})();

/*
* PD module "easyread" (tier 3 index B14) - the page viewer, old's "Please rotate your screen" overlay
* and the "Was this helpful?" thumbs of the [CB BG] Easy Read Leaflet block (cBBGEasyReadLeaflet.cshtml),
* as old PD's /learning-zone/easy-read/ (old: ekko-lightbox on a Bootstrap 3 modal, plus
* displayRotateMessage / hideRotateMessage and thumbsUpAndDownFromActions in /scripts/app.min.js).
*
* - Viewer: the magnifier opens ONE shared dialog with the leaflet's pages (data-pages on the link).
*   The title is the page's name; the image is at most 80% of the window tall; the two half-width hit
*   areas page back and forward, as do the Left/Right keys, and paging wraps round at both ends. Esc,
*   the close X or a click outside the dialog closes it, and focus goes back to the magnifier.
* - Rotate overlay: on a portrait screen, opening the viewer also shows the overlay over everything
*   (theme CSS shows it only while portrait). As old it stays until the screen turns: a change of
*   orientation that ends in portrait hides it again.
* - Thumbs: a click replaces the question and both thumbs with "Thank you" (data-thanks), as old's
*   form did on success. NOTHING is sent anywhere: storeEasyReadRating below is the hook.
* A no-op on every page without the block (nothing is bound unless a leaflet is on the page).
*/
(function () {
    /*
    * RATINGS STORAGE HOOK - deliberately does nothing (Sam 01/10: storage is an open question).
    * Old posted every click to an Umbraco Forms record (form "ThumbsUpDownRating",
    * 03f6a8ea-7c94-4314-b92d-630c116a35e6: the rating plus the leaflet's node id). The new site has no
    * ratings store and no Umbraco Forms, so until one is chosen this sends no request and no analytics
    * event. Plug the store in here; the UI does not wait for it, as the rating is already shown as done.
    *   rating = { leaflet: '<leaflet title>', value: 'Thumbs up' | 'Thumbs down', page: '<path>' }
    */
    function storeEasyReadRating(rating) {
        return rating;
    }

    var viewer = null;
    var rotate = null;
    var state = { pages: [], index: 0, opener: null, open: false, closeTimer: null };
    var portrait = window.matchMedia ? window.matchMedia('(orientation: portrait)') : null;

    function buildViewer() {
        var root = document.createElement('div');
        root.className = 'easyread-lightbox';
        root.setAttribute('role', 'dialog');
        root.setAttribute('aria-modal', 'true');
        root.setAttribute('aria-labelledby', 'easyread-lightbox-title');
        root.tabIndex = -1;
        root.hidden = true;
        root.innerHTML =
            '<div class="easyread-lightbox__backdrop"></div>' +
            '<div class="easyread-lightbox__dialog">' +
                '<div class="easyread-lightbox__header">' +
                    '<button type="button" class="easyread-lightbox__close" aria-label="Close"></button>' +
                    '<h4 class="easyread-lightbox__title" id="easyread-lightbox-title"></h4>' +
                '</div>' +
                '<div class="easyread-lightbox__body">' +
                    '<div class="easyread-lightbox__stage"></div>' +
                    '<button type="button" class="easyread-lightbox__nav easyread-lightbox__nav--prev" aria-label="Previous page"></button>' +
                    '<button type="button" class="easyread-lightbox__nav easyread-lightbox__nav--next" aria-label="Next page"></button>' +
                '</div>' +
            '</div>';
        document.body.appendChild(root);
        viewer = {
            root: root,
            dialog: root.querySelector('.easyread-lightbox__dialog'),
            title: root.querySelector('.easyread-lightbox__title'),
            close: root.querySelector('.easyread-lightbox__close'),
            stage: root.querySelector('.easyread-lightbox__stage'),
            prev: root.querySelector('.easyread-lightbox__nav--prev'),
            next: root.querySelector('.easyread-lightbox__nav--next')
        };
        viewer.close.addEventListener('click', closeViewer);
        viewer.prev.addEventListener('click', function () { showPage(state.index - 1); });
        viewer.next.addEventListener('click', function () { showPage(state.index + 1); });
        // a click outside the dialog (the backdrop or the padding round it) closes, as Bootstrap's modal
        root.addEventListener('click', function (e) {
            if (!viewer.dialog.contains(e.target)) {
                closeViewer();
            }
        });
    }

    function showPage(i) {
        var n = state.pages.length;
        if (!n) {
            return;
        }
        state.index = ((i % n) + n) % n;
        var page = state.pages[state.index];
        var wanted = state.index;
        viewer.title.textContent = page.title || ' ';
        viewer.stage.innerHTML = '<div class="easyread-lightbox__loading">Loading...</div>';
        var img = new Image();
        img.onload = function () {
            if (!state.open || state.index !== wanted) {
                return;
            }
            var el = document.createElement('img');
            el.className = 'easyread-lightbox__img';
            el.alt = page.title || '';
            el.src = img.src;
            el.style.maxHeight = (document.documentElement.clientHeight * 0.8) + 'px';
            viewer.stage.innerHTML = '';
            viewer.stage.appendChild(el);
        };
        img.onerror = function () {
            if (state.index === wanted) {
                viewer.stage.textContent = 'Failed to load image: ' + page.src;
            }
        };
        img.src = page.src;
        if (n > 1) {
            new Image().src = state.pages[(state.index + 1) % n].src; // old preloads the next page
        }
    }

    function openViewer(link) {
        var pages;
        try {
            pages = JSON.parse(link.getAttribute('data-pages') || '[]');
        } catch (err) {
            pages = [];
        }
        if (!pages.length) {
            return false;
        }
        if (!viewer) {
            buildViewer();
        }
        clearTimeout(state.closeTimer);
        state.pages = pages;
        state.opener = link;
        state.open = true;
        // as Bootstrap's modal: lock the page, keeping it where it is when the scrollbar goes
        var scrollbar = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.classList.add('easyread-lightbox-open');
        if (scrollbar > 0) {
            document.body.style.paddingRight = scrollbar + 'px';
        }
        viewer.root.classList.toggle('has-pages', pages.length > 1);
        viewer.root.hidden = false;
        void viewer.root.offsetWidth; // start the fade from 0
        viewer.root.classList.add('is-in');
        viewer.root.focus();
        showPage(0);
        if (portrait && portrait.matches) {
            showRotate();
        }
        return true;
    }

    function closeViewer() {
        if (!state.open) {
            return;
        }
        state.open = false;
        hideRotate(); // the hint belongs to the viewer: never leave the page covered after a close (PR review)
        viewer.root.classList.remove('is-in');
        state.closeTimer = setTimeout(function () {
            viewer.root.hidden = true;
            viewer.stage.innerHTML = '';
            document.documentElement.classList.remove('easyread-lightbox-open');
            document.body.style.paddingRight = '';
        }, 150);
        if (state.opener && state.opener.focus) {
            state.opener.focus();
        }
    }

    function showRotate() {
        if (!rotate) {
            rotate = document.createElement('div');
            rotate.className = 'easyread-rotate';
            rotate.innerHTML = '<div><span class="easyread-rotate__icon" aria-hidden="true"></span><span class="easyread-rotate__text">Please rotate your screen</span></div>';
            // Old's hint stays until the screen turns. Here a tap (or Enter / Space) also dismisses it, so a
            // device locked to portrait can still use the viewer (WCAG 1.3.4, PR review).
            rotate.setAttribute('role', 'button');
            rotate.setAttribute('tabindex', '0');
            rotate.setAttribute('aria-label', 'Please rotate your screen. Tap to dismiss');
            rotate.addEventListener('click', hideRotate);
            rotate.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                    e.preventDefault();
                    hideRotate();
                }
            });
            document.body.appendChild(rotate);
        }
        rotate.classList.add('is-shown');
        rotate.focus({ preventScroll: true }); // reachable from the keyboard straight away (PR review)
    }

    function hideRotate() {
        if (rotate && rotate.classList.contains('is-shown')) {
            rotate.classList.remove('is-shown');
            if (state.open && viewer && viewer.root.focus) {
                viewer.root.focus();
            }
        }
    }

    function onOrientationChange() {
        if (rotate && portrait.matches) {
            rotate.classList.remove('is-shown');
        }
    }

    function onKeydown(e) {
        if (!state.open) {
            return;
        }
        var key = e.key;
        if (key === 'Escape' || key === 'Esc') {
            e.preventDefault();
            closeViewer();
        } else if ((key === 'ArrowRight' || key === 'Right') && state.pages.length > 1) {
            e.preventDefault();
            showPage(state.index + 1);
        } else if ((key === 'ArrowLeft' || key === 'Left') && state.pages.length > 1) {
            e.preventDefault();
            showPage(state.index - 1);
        } else if (key === 'Tab') {
            // While the rotate hint covers the viewer, it is the only stop, so a keyboard or switch user can
            // reach its Enter / Space dismissal (PR review). It is visible in portrait only.
            if (rotate && rotate.classList.contains('is-shown') && portrait && portrait.matches) {
                e.preventDefault();
                rotate.focus({ preventScroll: true });
                return;
            }
            // keep focus in the dialog: close, previous, next
            var stops = [viewer.close];
            if (state.pages.length > 1) {
                stops.push(viewer.prev, viewer.next);
            }
            var at = stops.indexOf(document.activeElement);
            if (at === -1) {
                e.preventDefault();
                stops[e.shiftKey ? stops.length - 1 : 0].focus();
            } else if (!e.shiftKey && at === stops.length - 1) {
                e.preventDefault();
                stops[0].focus();
            } else if (e.shiftKey && at === 0) {
                e.preventDefault();
                stops[stops.length - 1].focus();
            }
        }
    }

    function onClick(e) {
        var target = e.target;
        if (!target || !target.closest) {
            return;
        }
        var opener = target.closest('[data-easyread-open]');
        if (opener) {
            if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
                return; // let a new-tab click open the page image itself
            }
            if (openViewer(opener)) {
                e.preventDefault();
            }
            return;
        }
        var thumb = target.closest('[data-easyread-rating] [data-rating]');
        if (thumb) {
            var box = thumb.closest('[data-easyread-rating]');
            storeEasyReadRating({
                leaflet: box.getAttribute('data-leaflet') || '',
                value: thumb.getAttribute('data-rating'),
                page: window.location.pathname
            });
            box.textContent = box.getAttribute('data-thanks') || 'Thank you';
            box.classList.add('is-thanked');
            box.setAttribute('tabindex', '-1');
            box.focus();
        }
    }

    function initEasyRead() {
        if (!document.querySelector('[data-easyread-leaflet]')) {
            return;
        }
        document.addEventListener('click', onClick);
        document.addEventListener('keydown', onKeydown);
        if (portrait) {
            if (portrait.addEventListener) {
                portrait.addEventListener('change', onOrientationChange);
            } else if (portrait.addListener) {
                portrait.addListener(onOrientationChange);
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initEasyRead);
    } else {
        initEasyRead();
    }
})();

/*
* 13307 TG7 - floated RTE images keep their own inline size on tablets and phones, as old (KD/PD/MHL only, this file is
* per-theme, not shared)
*
* The shared RTE rules (themes/shared/scss/_umbracoComponents.scss) unfloat RTE images below 1024px and force them to
* width: 100% !important, which beats the image's style attribute. Old keeps an <img style="width: 75px; float: left">
* a 75px float at every width. _rtefloat13307.scss puts the float and margin back; CSS cannot recover the attribute's
* own width, so this re-sets each inline declaration of a floated RTE image as !important (an !important inline value
* beats an !important stylesheet one). The values are the editor's own, so nothing changes from 1024px up. A no-op on
* pages without a floated RTE image.
*/
(function () {
    function keepRteFloatSizes() {
        var imgs = document.querySelectorAll('.rte-content img[style*="float"]');
        for (var i = 0; i < imgs.length; i++) {
            var style = imgs[i].style;
            var props = [];
            for (var k = 0; k < style.length; k++) {
                props.push(style[k]);
            }
            for (var p = 0; p < props.length; p++) {
                style.setProperty(props[p], style.getPropertyValue(props[p]), 'important');
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', keepRteFloatSizes);
    } else {
        keepRteFloatSizes();
    }
})();

/*
* 13307 tables - RTE table cells keep their own sizes on phones, and a table too wide for its column may break its
* words (KD/PD/MHL only, this file is per-theme, not shared)
*
* _rtetables13307.scss keeps RTE tables as tables on phones, with words wrapping whole as old.
* 1. The shared rules force every cell to width: 100% / height: auto !important below 640px (1024 in a card), which
*    beats the cells' style attributes; old keeps them (fibre's three 33.3% columns). CSS cannot get back to the
*    attribute's value, so a cell's inline width and height are re-set as !important (old's .image-table cells are
*    left alone: old's own !important rule makes those full width).
* 2. A few tables are wider than a phone column (glycaemic-index's four picture columns: old's table is 517 wide at
*    390 and its last column is cut off the page). CSS cannot tell when a table overflows, so such a table is marked
*    .is-squeezed: the CSS then lets its words break and its cells share the width by content, so every column stays
*    on the page. Re-checked on resize and when a tab is opened (a table in a hidden tab panel has no width until then).
* A no-op on pages without an RTE table.
*/
(function () {
    // priority '' hands a cell's width back to the stylesheet (auto on a phone), 'important' keeps the attribute's
    function setCellSizes(table, widthPriority) {
        var cells = table.querySelectorAll('tr, td, th');
        for (var c = 0; c < cells.length; c++) {
            var style = cells[c].style;
            if (style.width) {
                style.setProperty('width', style.width, widthPriority);
            }
            if (style.height) {
                style.setProperty('height', style.height, 'important');
            }
        }
    }

    function squeezeTables() {
        var tables = document.querySelectorAll('.rte-content table, .card-section table');
        for (var i = 0; i < tables.length; i++) {
            var table = tables[i];
            var box = table.parentElement;
            if (table.classList.contains('image-table')) {
                continue;
            }
            table.classList.remove('is-squeezed');
            setCellSizes(table, 'important');
            if (box && table.offsetWidth > box.clientWidth + 1) {
                // too wide: its words may break, and the columns share the width by content, not by the
                // attribute's percentages (which leave a long-text column a few words wide)
                table.classList.add('is-squeezed');
                setCellSizes(table, '');
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', squeezeTables);
    } else {
        squeezeTables();
    }
    window.addEventListener('load', squeezeTables);

    var squeezeTimer;
    function squeezeSoon() {
        clearTimeout(squeezeTimer);
        squeezeTimer = setTimeout(squeezeTables, 150);
    }
    window.addEventListener('resize', squeezeSoon);
    document.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('.tabs-title, [role="tab"]')) {
            squeezeSoon();
        }
    });
})();
